<template>
    <router-link :to="'/files/' + file.id" v-if="file">
        <Icon :name="typeIcon" class="icon"/>
        <p class="name">{{file.name}}</p>
        <p class="size">{{formattedSize}}</p>
    </router-link>
</template>

<script>
    import {fileType2IconName, formatSize} from '../other/page-global';
    import Icon from './Icon';

    export default {
        name: 'FileListEntry',
        components: {Icon},
        props: {
            file: {
                type: Object,
                required: true
            }
        },
        watch: {
            file() {
                this.formattedSize = formatSize(this.file.size);
                this.typeIcon = fileType2IconName(this.file.type);
            }
        },
        data() {
            return {
                formattedSize: this.file ? formatSize(this.file.size) : '',
                typeIcon: fileType2IconName(this.file?.type)
            };
        }
    };
</script>

<style scoped>
    a {
        text-align: left;
        padding: 8px 4px;
        text-decoration: none;
        color: white;
        display: grid;
        grid-template-areas: 'icon name' 'icon sum';
        grid-template-columns: 48px auto;
        align-items: center;
    }

    a > * {
        margin: 2px;
    }

    .icon {
        grid-area: icon;
        justify-self: center;
    }

    .name {
        word-break: break-word;
        flex: 1;
        font-size: 1.1em;
        max-height: 3.3em;
        overflow: hidden;
        text-overflow: ellipsis;
        grid-area: name;
    }

    .size {
        font-size: .9em;
        color: #ffffffbb;
        grid-area: sum;
    }
</style>
